<template>
  <b-modal :id="modalId" ref="modal" :centered="true">
    <template v-slot:modal-title>
      <h5 class="modal-title" id="model-label">
        Reset Password
      </h5>
    </template>

    <input type="email" v-model="email" id="reset-email" class="form-control" placeholder="Email" required>
    <small id="reset-email-help" class="form-text text-muted">
      An email will be sent with a link to reset your password
    </small>

    <p id="help-text" class="form-feedback text-danger">{{ helpText }}</p>

    <template v-slot:modal-footer>
      <button @click="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal" id="modal_cancel">Close</button>
      <button @click="sendResetLink" type="button" class="btn btn-primary" id="modal_action">Reset</button>
    </template>
  </b-modal>
</template>


<script>
import DataService from '../../services/DataService';

const ds = DataService.getInstance()

export default {
  name: "ResetPasswordModal",
  props: {
    modalId: String
  },
  data() {
    return {
      email: '',
      helpText: '',
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.modalId)
    },
    async sendResetLink() {
      if(this.email) {
        try {
          await ds.requestUserResetPassword(this.email);
          this.helpText = `Email sent to ${this.email}`;
        } catch(error) {
          this.helpText = capitalizeFirstLetter(error.message);
        }
      } else {
        this.helpText = 'You must provide an email'
      }
    }
  }
}
</script>

<style scoped>
input {
  height: 55px;
}
</style>